<template>
  <div class="content event-edit-page">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 v-if="!isEdit" class="text-center">Add Event</h2>
      <h2 v-if="isEdit" class="text-center">Edit Event</h2>
    </div>
    <div class="row">
      <div class="col-md-8">
        <card>
          <form onSubmit="return false;">
            <div class="row">
              <div class="col-lg-6 col-md-8">
                <span class="pb-2" style="color: white"
                  >Auto set dynamic Price</span
                >
                <base-switch
                  class="ml-4 mt-2"
                  v-model="is_dynamic_price"
                  on-text="ON"
                  off-text="OFF"
                ></base-switch>
              </div>

              <div class="col-lg-6 col-md-8">
                <span class="pb-2" style="color: white"
                  >Disable Bots Fill Slots</span
                >
                <base-switch
                  class="ml-4 mt-2"
                  v-model="bots_disabled_buy_cron"
                  on-text="ON"
                  off-text="OFF"
                ></base-switch>
              </div>

              <div class="col-md-12">
                <base-input
                  type="text"
                  label="Name *"
                  maxlength="50"
                  placeholder="Name"
                  v-model="event_name"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="date"
                  label="Event Start Date *"
                  v-model="date"
                ></base-input>
              </div>
              <div class="col-md-6">
                <label>City *</label>
                <select
                  class="location form-control"
                  v-model="city"
                  style="width: 100%; color: white !important"
                  disabled
                >
                  <option :value="defaultCity" style="color: black !important">
                    {{ defaultCity }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <base-input
                  type="time"
                  id="txtStartTime"
                  value="5:00 PM"
                  label="Start Time *"
                  v-model="start_time"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="time"
                  id="txtEndTime"
                  value="01:23 AM"
                  label="End Time *"
                  v-model="end_time"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" v-if="!is_dynamic_price">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Early Price *"
                  placeholder="Early Price"
                  v-model="early_price"
                  @keyup="numericcost('early_price')"
                ></base-input>
              </div>

              <div class="col-md-6" v-if="!is_dynamic_price">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Day-of-Event Fee *"
                  placeholder="Day-of-Event Fee"
                  v-model="day_of_event_fee"
                  @keyup="numericcost('day_of_event_fee')"
                ></base-input>
              </div>

              <div class="col-md-6" v-if="!is_dynamic_price">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Regular Price *"
                  placeholder="Regular Price"
                  v-model="regular_price"
                  @keyup="numericcost('regular_price')"
                ></base-input>
              </div>
              <div class="col-md-4" v-if="is_dynamic_price">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Price *"
                  placeholder="Price"
                  v-model="original_price"
                  @keyup="numericcost('original_price')"
                ></base-input>
              </div>
              <div class="col-md-4" v-if="is_dynamic_price">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Min price *"
                  placeholder="Min Price"
                  v-model="min_price"
                  @keyup="numericcost('min_price')"
                ></base-input>
              </div>
              <div class="col-md-4" v-if="is_dynamic_price">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Max Price *"
                  placeholder="Max Price"
                  v-model="max_price"
                  @keyup="numericcost('max_price')"
                ></base-input>
              </div>
            
              <!-- Phase 1 — Task 3G: per-event check-in time, included in 2-hour reminder SMS -->
              <!-- Phase 1 — Task 3A: per-event toggle to expose "Request to Host" button to users -->
              <div class="col-md-6 d-flex align-items-center">
                <label style="margin-right:10px;">Allow Host Requests</label>
                <input type="checkbox" v-model="host_request_enabled" style="transform: scale(1.4); margin-top: 8px;" />
              </div>
              <!-- Phase 1 — Task 3F: per-event auto no-show charge timing.
                   Separate from Late Fee Date/Time (which are early-bird pricing cutoff). -->
              <div
                class="col-md-6"
                v-if="
                  is_unlimited_bookings !== 'true' ||
                  is_unlimited_bookings !== true
                "
              >
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('total_slots')"
                  label="Total Slots *"
                  placeholder="Total Slots"
                  v-model="total_slots"
                >
                </base-input>
              </div>

              <div
                class="col-md-6"
                v-if="
                  is_unlimited_bookings !== 'true' ||
                  is_unlimited_bookings !== true
                "
              >
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('minimum_players')"
                  label="Minimum Players *"
                  placeholder="Minimum Players"
                  v-model="minimum_players"
                >
                </base-input>
              </div>

              <div
                class="col-md-6"
                v-if="
                  is_unlimited_bookings !== 'true' ||
                  is_unlimited_bookings !== true
                "
              >
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('additional_slots')"
                  label="Additional Slots *"
                  placeholder="Additional Slots"
                  v-model="additional_slots"
                >
                </base-input>
              </div>

              <div class="col-md-6">
                <label>Event/Game Type</label>
                <select
                  class="location form-control"
                  v-model="game_type"
                  style="width: 100%; color: white !important"
                >
                  <!-- Normal options -->
                  <option
                    v-for="env in GameTypes"
                    :key="env.game_name"
                    :value="env.game_name"
                  >
                    {{ env.game_name }}
                  </option>

                  <!-- Extra disabled option if current v-model not in list -->
                  <option
                    v-if="
                      game_type &&
                      !GameTypes.some((g) => g.game_name === game_type)
                    "
                    :value="game_type"
                    disabled
                  >
                    {{ game_type }} (Not available)
                  </option>
                </select>
              </div>
            </div>
            <div class="row" v-if="!isEdit">
              <div class="col-md-6">
                <label>Location *</label>
                <input
                  class="location form-control"
                  id="auto-complete-text"
                  v-model="address"
                  placeholder="Search Location"
                />
              </div>

              <div class="col-md-6">
                <label>Shoe Type</label>
                <select
                  class="location form-control"
                  v-model="shoe_type"
                  style="width: 100%; color: white !important"
                >
                  <option style="color: black !important"></option>
                  <option style="color: black !important">Any</option>
                  <option style="color: black !important">No Cleats</option>
                  <option style="color: black !important">
                    Non-marking Indoor Only
                  </option>
                </select>
              </div>
            </div>
            <div class="row" v-if="isEdit">
              <div class="col-md-6">
                <label>Location *</label>
                <input
                  class="location form-control"
                  id="auto-complete-text"
                  placeholder="Search Location"
                  v-model="address"
                />
              </div>

              <div class="col-md-6">
                <label>Shoe Type</label>
                <select
                  class="location form-control"
                  v-model="shoe_type"
                  style="width: 100%; color: white !important"
                >
                  <option style="color: black !important">Any</option>
                  <option style="color: black !important">No Cleats</option>
                  <option style="color: black !important">
                    Non-marking Indoor Only
                  </option>
                </select>
              </div>
            </div>

            <div class="row" v-if="event_type == 'Tournament'">
              <div class="col-md-6 mb-2">
                <label></label>
                <base-checkbox class="text-left" v-model="booking_with_team"
                  >Booking with Team?</base-checkbox
                >
              </div>
              <div class="col-md-6 mb-2">
                <label>Skill Level Optional</label>
                <base-checkbox class="text-left" v-model="skill_level_optional"
                  >Show skill levels ?</base-checkbox
                >
              </div>
            </div>

            <div
              class="row"
              v-if="event_type == 'Tournament' && skill_level_optional"
            >
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('beginner_slots')"
                  label="Beginner Slots *"
                  placeholder="Beginner Slots"
                  v-model="beginner_slots"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('intermediate_slots')"
                  label="Intermediate Slots *"
                  placeholder="Intermediate Slots"
                  v-model="intermediate_slots"
                >
                </base-input>
              </div>
            </div>

            <div class="row" v-if="event_type == 'Tournament'">
              <div class="col-md-6" v-if="skill_level_optional">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('advanced_slots')"
                  label="Advanced Slots *"
                  placeholder="Advanced Slots"
                  v-model="advanced_slots"
                >
                </base-input>
              </div>
            </div>

            <div class="row" v-if="event_type == 'Tournament'">
              <div class="col-md-6">
                <label>Select Tournament Type :</label>
                <select
                  class="location form-control"
                  v-model="tournament_type"
                  aria-placeholder="Select"
                  style="width: 100%; color: white !important"
                >
                  <option style="color: black !important">Men</option>
                  <option style="color: black !important">Women</option>
                  <option style="color: black !important">co-ed</option>
                  <option style="color: black !important">Open</option>
                </select>
              </div>
            </div>

            <div
              class="row"
              v-if="event_type == 'Tournament' && this.booking_with_team"
            >
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('team_size')"
                  label="Team Size *"
                  placeholder="Team Size"
                  v-model="team_size"
                ></base-input>
              </div>
              <div class="col-md-6 mb-2">
                <!-- <label></label> -->
                <base-checkbox class="text-left" v-model="only_team_booking"
                  >Only team Booking no individual?</base-checkbox
                >
              </div>
            </div>

            <div
              class="row"
              v-if="event_type == 'Tournament' && this.booking_with_team"
            >
              <div
                class="col-md-6"
                v-if="tournament_type == 'Open' && !this.only_team_booking"
              >
                <base-input
                  type="text"
                  maxlength="5"
                  label="Individual Slots*"
                  placeholder="Individual Slots"
                  v-model="individual_slots"
                  @keyup="onlyNum('individual_slots')"
                ></base-input>
              </div>
              <div class="col-md-6" v-if="tournament_type == 'Open'">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Team Count*"
                  placeholder="Team Count"
                  v-model="team_slots"
                  @keyup="onlyNum('team_slots')"
                ></base-input>
              </div>
            </div>

            <div
              class="row"
              v-if="event_type == 'Tournament' && this.booking_with_team"
            >
              <div class="col-md-6" v-if="tournament_type == 'Open'">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Early Team Price *"
                  placeholder="Team Price"
                  v-model="team_price"
                  @keyup="numericcost('team_price')"
                ></base-input>
              </div>
              <div class="col-md-6" v-if="tournament_type == 'Open'">
                <base-input
                  type="text"
                  maxlength="5"
                  label="Regular Team Price *"
                  placeholder="Regular Team Price"
                  v-model="regular_team_price"
                  @keyup="numericcost('regular_team_price')"
                ></base-input>
              </div>
            </div>

            <div
              class="row"
              v-if="
                (tournament_type == 'Men' || tournament_type == 'co-ed') &&
                event_type == 'Tournament' &&
                !this.only_team_booking
              "
            >
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('men_individual_slots')"
                  label="Men Individual *"
                  placeholder="Men Individual Slots"
                  v-model="men_individual_slots"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="numericcost('men_individual_price')"
                  label="Men Individual Price *"
                  placeholder="Men Individual Price"
                  v-model="men_individual_price"
                >
                </base-input>
              </div>
            </div>

            <div
              class="row"
              v-if="
                (tournament_type == 'Men' || tournament_type == 'co-ed') &&
                event_type == 'Tournament'
              "
            >
              <div class="col-md-6" v-if="this.booking_with_team">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('men_team_count')"
                  label="Men Team *"
                  placeholder="Men Team Count"
                  v-model="men_team_count"
                >
                </base-input>
              </div>
              <div class="col-md-6" v-if="this.booking_with_team">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="numericcost('men_team_price')"
                  label="Men Team Price *"
                  placeholder="Men Team Price"
                  v-model="men_team_price"
                >
                </base-input>
              </div>
            </div>

            <div
              class="row"
              v-if="
                (tournament_type == 'Women' || tournament_type == 'co-ed') &&
                event_type == 'Tournament' &&
                !this.only_team_booking
              "
            >
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('women_individual_slots')"
                  label="Women Individual *"
                  placeholder="Women Individual Slots"
                  v-model="women_individual_slots"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="numericcost('women_individual_price')"
                  label="Women Individual price *"
                  placeholder="Women Individual Price"
                  v-model="women_individual_price"
                >
                </base-input>
              </div>
            </div>

            <div
              class="row"
              v-if="
                (tournament_type == 'Women' || tournament_type == 'co-ed') &&
                event_type == 'Tournament'
              "
            >
              <div class="col-md-6" v-if="this.booking_with_team">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="onlyNum('women_team_count')"
                  label="Women Team *"
                  placeholder="Women Team Count"
                  v-model="women_team_count"
                >
                </base-input>
              </div>
              <div class="col-md-6" v-if="this.booking_with_team">
                <base-input
                  type="text"
                  maxlength="3"
                  @keyup="numericcost('women_team_price')"
                  label="Women Team price *"
                  placeholder="Women Team Price"
                  v-model="women_team_price"
                >
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Environment Type</label>
                <select
                  class="location form-control"
                  v-model="event_environment_type"
                  style="width: 100%; color: white !important"
                >
                  <option
                    style="color: black !important"
                    v-for="env in environmentTypes"
                    v-bind:key="env.envType"
                  >
                    {{ env.envType }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">

                <label>Age Limit *</label>
                <select
                  class="location form-control"
                  v-model="age_limit"
                  style="width: 100%; color: white !important"
                >
                  <option style="color: black !important">16+</option>
                  <option style="color: black !important">18+</option>
                </select>
              </div>
            </div>

            <div
              class="row"
              style="padding: 10px"
              v-if="event_type == 'Tournament'"
            >
              <div class="col-md-12">
                <base-checkbox class="text-left" v-model="substitute_player"
                  >Bring Substitute player</base-checkbox
                >
              </div>
            </div>

            <div class="row" style="padding: 10px">
              <div class="col-md-12">
                <base-checkbox class="text-left" v-model="waiver_form_mandatory"
                  >Waiver form mandatory</base-checkbox
                >
              </div>
            </div>

            <div class="row" style="padding: 10px">
              <div class="col-md-12">
                <base-checkbox
                  class="text-left"
                  v-model="no_noshow_and_start_game_reminder"
                  >No No-Show fee and 2nd message?</base-checkbox
                >
              </div>
            </div>

            <div class="row" style="padding: 10px">
              <div class="col-md-12">
                <base-checkbox class="text-left" v-model="displayRegularPrice">
                  Display Regular Price</base-checkbox
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>Organizer list*</label>
                <div class="row">
                  <div class="col-md-5">
                    <SelectUser
                      @passValue="getValueOfList"
                      class="location form-control"
                    >
                    </SelectUser>
                  </div>
                  <div class="col-md-4">
                    <base-checkbox class="text-left" v-model="isChecked">
                      create a booking for organizer
                    </base-checkbox>
                    <base-checkbox class="text-left" v-model="isBotCancel"
                      >Bot cancel organizer's booking?</base-checkbox
                    >
                  </div>
                  <div class="col-md-3">
                    <base-button
                      @click="assignToEvent()"
                      native-type="submit"
                      type="primary"
                      value="Compares"
                      size="sm"
                      >Assign to event
                    </base-button>
                  </div>
                </div>

                <div
                  class="row mt-4"
                  v-for="orgainzer in organizers"
                  :key="orgainzer.userId"
                >
                  <p class="col-md-4 pt-3 text-left">
                    {{ orgainzer.userName }}
                  </p>
                  <base-button @click="remove(orgainzer.userId)"
                    ><i
                      title="Delete"
                      class="fa fa-trash-alt text-danger icon-padding"
                      style="cursor: pointer"
                    ></i
                    >&nbsp;&nbsp;Remove</base-button
                  >
                </div>
              </div>
            </div>
            <div class="row mt-4 d-none">
              <div class="col-md-12">
                <base-input label="Rules*">
                  <textarea
                    maxlength="250"
                    class="form-control"
                    placeholder="Rules"
                    v-model="rules"
                  ></textarea>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input label="Description *">
                  <textarea
                    class="form-control"
                    placeholder="Description"
                    v-model="description"
                  ></textarea>
                </base-input>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-md-12">
                <base-input label="Two Hour Reminder Text">
                  <textarea
                    rows="6"
                    class="form-control max-height-custom"
                    placeholder="Two Hour Reminder Text"
                    v-model="two_hour_reminder_text"
                    style="max-height: 100px"
                  ></textarea>
                  <!-- Phase 1 — Task 3G: discoverability for the new placeholders. -->
                  <small class="text-muted" style="display:block; margin-top:4px;">
                    Available placeholders:
                    <code>{first_name}</code>,
                    <code>{event_name}</code>,
                    <code>{start_time}</code>,
                    <code>{address}</code>,
                    <code>{host_name}</code>,
                    <code>{check_in_time}</code>
                  </small>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-8 ml-3">
                <span class="pb-2" style="color: white"
                  >Hide Number of Booked Users</span
                >
                <base-switch
                  class="ml-4 mt-2"
                  v-model="showUsers"
                  on-text="OFF "
                  off-text="ON"
                ></base-switch>
              </div>
            </div>
            <hr />

            <div class="row" v-if="!isEdit">
              <div class="col-md-12">
                <h4>
                  <base-checkbox v-model="isRepeate" @change="repeateEndDate">
                    Repeat This Event ?</base-checkbox
                  >
                </h4>
              </div>
            </div>
            <div class="row" v-if="isRepeate">
              <div class="col-md-6">
                <label>Repeat every</label>
                <select
                  label="Repeat every"
                  class="form-control"
                  style="width: 100%; color: white !important"
                  v-model="repeat_on_every"
                >
                  <option style="color: black !important">Daily</option>
                  <option style="color: black !important">Weekly</option>
                  <option style="color: black !important">Bi-Weekly</option>
                  <option style="color: black !important">Monthly</option>
                  <option style="color: black !important">Yearly</option>
                </select>
              </div>
              <div class="col-md-6">
                <base-input
                  label="Repeat Ends"
                  type="date"
                  v-model="repeat_end_date_value"
                ></base-input>
              </div>
            </div>
            <hr />

            <base-button
              v-if="!isEdit"
              native-type="submit"
              type="primary"
              @click="AddEve()"
              value="Compares"
              class="btn-fill"
              :disabled="loading"
              >Save
            </base-button>

            <base-button
              v-if="isEdit"
              native-type="submit"
              type="primary"
              value="Compares"
              @click="UpdateEve()"
              class="btn-fill"
              :disabled="loading"
              >Update
            </base-button>

            <base-button
              v-if="isRecc"
              native-type="submit"
              type="primary"
              value="Compares"
              @click="UpdateFutureEvents()"
              class="btn-fill ml-1"
              :disabled="loading"
              >Update All Future events
            </base-button>
          </form>
        </card>
      </div>
      <div class="col-md-4" v-for="user in [1]" v-bind:key="user">
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <div class="col-md-12 col-sm-12" v-if="!isEdit">
              <h4 class="card-title">Image</h4>
              <image-upload
                :src="image"
                @change="onImageChange"
                select-text="Select Image"
              />
            </div>
            <div class="col-md-12 col-sm-12" v-if="isEdit">
              <h4 class="card-title">Event Image</h4>
              <image-upload
                :src="image"
                @change="onImageChange"
                select-text="Update Image"
              />
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ImageUpload,
  BaseCheckbox,
  BaseRadio,
  SelectUser,
  BaseSwitch,
} from "src/components/index";
import { stripVTControlCharacters } from "util";
import { image, is } from "vee-validate/dist/rules";

export default {
  components: {
    ImageUpload,
    BaseRadio,
    BaseCheckbox,
    SelectUser,
    BaseSwitch,
  },
  data() {
    return {
      defaultEventType: "Sports",
      defaultCity: "Calgary",

      shoe_type: "",
      rental_options: "",
      rental_price: "",
      age_limit: "16+",
      isChecked: false,
      isBotCancel: false,
      displayRegularPrice: false,
      popUpValue: "",
      popUpText: "",
      lat: "",
      lng: "",
      address: "",
      rules: "-",
      city: "Calgary",
      event_name: "",
      early_price: "",
      day_of_event_fee: "0",
      regular_price: "",
      team_price: "",
      regular_team_price: "",
      skill_level_optional: false,
      booking_with_team: false,
      only_team_booking: false,
      waiver_form_mandatory: false,
      no_noshow_and_start_game_reminder: false,
      tournament_type: "",
      individual_slots: "",
      team_slots: "",
      men_individual_slots: "",
      men_team_count: "",
      men_individual_price: "",
      men_team_price: "",
      women_individual_slots: "",
      women_team_count: "",
      women_individual_price: "",
      women_team_price: "",
      substitute_player: false,
      late_fee_date: "",
      late_fee_time: "",
      check_in_time: "",
      host_request_enabled: false,
      // Phase 1 — Task 3F: dedicated no-show charge timing fields
      auto_no_show_charge_date: "",
      auto_no_show_charge_time: "",
      date: "",
      endDate: "",
      start_time: "",
      end_time: "",
      total_slots: "",
      minimum_players: "0",
      additional_slots: "",
      beginner_slots: "",
      intermediate_slots: "",
      advanced_slots: "",
      team_size: "",
      environmentTypes: [],
      GameTypes: [],
      description: "",
      two_hour_reminder_text: "",
      event_type: "Sports",
      event_environment_type: "",
      game_type: "",
      yester: "",
      image: null,
      isEdit: false,
      loading: false,
      imageUploaded: false,
      isRepeate: false,
      repeat_on_every: "Daily",
      repeat_end_date_value: "",
      isRecc: false,
      organizers: [],
      showUsers: true,
      is_partial: false,
      is_disable_cancellation: false,
      is_unlimited_bookings: false,
      is_dynamic_price: false,
      bots_disabled_buy_cron: false,
      original_price: "",
      min_price: "",
      max_price: "",
      // Store the last auto-generated reminder text to avoid overwriting user edits
      lastAutoReminderText: "",
    };
  },

  async mounted() {
    this.event_type = this.defaultEventType;
    this.city = this.defaultCity;

    let environmentApiResponse = await this.$apiService.getCall(
      "environment/get-environments"
    );
    this.environmentTypes = environmentApiResponse.apidata.Data || [];

    let gametypeApiResponse = await this.$apiService.getCall(
      "event/getallgametypes"
    );
    this.GameTypes = gametypeApiResponse.apidata.games || [];
    this.GameTypes.unshift({ _id: "", name: "" });
    console.log(this.GameTypes);

    let yesterday = new Date();
    this.yester = new Date(yesterday.getTime() - 24 * 60 * 60 * 1000);
    let id = this.$route.query.id;
    if (id == -1) {
      this.isEdit = false;
    } else {
      // value = "Compare";
      this.isEdit = true;
      let eve = await this.$apiService.getCall(
        "event/eventbyId/" + id + `?isUpdatedData=true`
      );
      console.log("apidata", eve);
      this.event_name = eve.apidata.Data.event.event_name;
      this.address = eve.apidata.Data.event.address;
      this.total_slots = eve.apidata.Data.event.total_slots;
      this.minimum_players =
        eve.apidata.Data.event.minimum_players !== undefined &&
        eve.apidata.Data.event.minimum_players !== null &&
        eve.apidata.Data.event.minimum_players !== ""
          ? String(eve.apidata.Data.event.minimum_players)
          : "1";
      this.additional_slots = eve.apidata.Data.event.additional_slots;
      this.beginner_slots = eve.apidata.Data.event.beginner_slots;
      this.intermediate_slots = eve.apidata.Data.event.intermediate_slots;
      this.advanced_slots = eve.apidata.Data.event.advanced_slots;
      this.team_size = eve.apidata.Data.event.team_size;
      this.image = eve.apidata.Data.event.image;
      this.description = eve.apidata.Data.event.description;
      this.two_hour_reminder_text =
        eve.apidata.Data.event.two_hour_reminder_text;
      this.lastAutoReminderText = eve.apidata.Data.event.two_hour_reminder_text;
      this.early_price = eve.apidata.Data.event.early_price;
      this.day_of_event_fee = eve.apidata.Data.event.day_of_event_fee;
      this.regular_price = eve.apidata.Data.event.regular_price;
      this.is_partial = eve.apidata.Data.event.is_partial;
      this.is_disable_cancellation =
        eve.apidata.Data.event.is_disable_cancellation;
      this.is_unlimited_bookings = eve.apidata.Data.event.is_unlimited_bookings;
      this.is_dynamic_price = eve.apidata.Data.event.is_dynamic_price;
      this.bots_disabled_buy_cron =
        !!eve.apidata.Data.event.bots_disabled_buy_cron;
      this.original_price = eve.apidata.Data.event.original_price;
      this.min_price = eve.apidata.Data.event.min_price;
      this.max_price = eve.apidata.Data.event.max_price;
      this.team_price = eve.apidata.Data.event.team_price;
      this.regular_team_price = eve.apidata.Data.event.regular_team_price;
      this.skill_level_optional = eve.apidata.Data.event.skill_level_optional;
      this.booking_with_team = eve.apidata.Data.event.booking_with_team;
      this.only_team_booking = eve.apidata.Data.event.only_team_booking;
      this.waiver_form_mandatory =
        eve.apidata.Data.event.waiver_form_mandatory || false;
      this.no_noshow_and_start_game_reminder =
        eve.apidata.Data.event.no_noshow_and_start_game_reminder || false;
      this.tournament_type = eve.apidata.Data.event.tournament_type;
      this.individual_slots = eve.apidata.Data.event.individual_slots;
      this.team_slots = eve.apidata.Data.event.team_slots;
      this.men_individual_slots = eve.apidata.Data.event.men_individual_slots;
      this.men_team_count = eve.apidata.Data.event.men_team_count;
      this.men_individual_price = eve.apidata.Data.event.men_individual_price;
      this.men_team_price = eve.apidata.Data.event.men_team_price;
      this.women_individual_slots =
        eve.apidata.Data.event.women_individual_slots;
      this.women_team_count = eve.apidata.Data.event.women_team_count;
      this.women_individual_price =
        eve.apidata.Data.event.women_individual_price;
      this.women_team_price = eve.apidata.Data.event.women_team_price;
      this.substitute_player = eve.apidata.Data.event.substitute_player;
      this.late_fee_date = eve.apidata.Data.event.late_fee_date;
      this.late_fee_time = eve.apidata.Data.event.late_fee_time;
      this.check_in_time = eve.apidata.Data.event.check_in_time || "";
      this.host_request_enabled = !!eve.apidata.Data.event.host_request_enabled;
      // Phase 1 — Task 3F: dedicated no-show charge timing
      this.auto_no_show_charge_date = eve.apidata.Data.event.auto_no_show_charge_date || "";
      this.auto_no_show_charge_time = eve.apidata.Data.event.auto_no_show_charge_time || "";
      this.date = eve.apidata.Data.event.date;
      this.endDate = eve.apidata.Data.event.date || "";
      this.start_time = eve.apidata.Data.event.start_time;
      this.end_time = eve.apidata.Data.event.end_time;
      this.event_type = this.defaultEventType;
      this.event_environment_type =
        eve.apidata.Data.event.event_environment_type;
      this.shoe_type = eve.apidata.Data.event.shoe_type;
      this.age_limit = eve.apidata.Data.event.age_limit;
      this.game_type = eve.apidata.Data.event.game_type;
      this.rules = eve.apidata.Data.event.rules;
      this.lat = eve.apidata.Data.event.lat;
      this.lng = eve.apidata.Data.event.long;
      this.organizers = eve.apidata.Data.event.organizers;
      this.showUsers = eve.apidata.Data.event.showUsers;
      this.displayRegularPrice = eve.apidata.Data.event.displayRegularPrice;
      console.log(eve.apidata.Data.event.showUsers);
      if (typeof eve.apidata.Data.event.event_recurrence_id !== "undefined") {
        this.isRecc = true;
      } else {
        this.event_recurrence_id = "";
      }

      console.log("event data : ");
    }

    var _self = this;

    var input = document.getElementById("auto-complete-text");
    var autocomplete = new google.maps.places.Autocomplete(input);

    google.maps.event.addListener(autocomplete, "place_changed", function () {
      var place = autocomplete.getPlace();
      // _self.address = place.formatted_address;
      _self.address = input.value;
      _self.lat = place.geometry.location.lat();
      _self.lng = place.geometry.location.lng();
    });
  },
  methods: {
    // Generate the two hour reminder text based on event type/game type and other fields
    generateTwoHourReminderText() {
      // If no_noshow_and_start_game_reminder is true, set simple message and skip other logic

      if (this.no_noshow_and_start_game_reminder) {
        this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!`;
        this.two_hour_reminder_text = this.lastAutoReminderText;
        return;
      }
      // Custom message overrides all
      if (
        this.two_hour_reminder_text &&
        this.two_hour_reminder_text.trim() !== "" &&
        this.two_hour_reminder_text !== this.lastAutoReminderText
      ) {
        // User has set a custom message, do not override
        return;
      }

      // Tournament logic
      if (this.event_type === "Tournament") {
        if (
          this.booking_with_team &&
          !this.only_team_booking &&
          this.individual_slots &&
          this.team_slots
        ) {
          this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!\n\nYou may be subject to both $80.00 and $100.00 No Show Fees depending on your registration type. Please reply to your organizer at 403-990-2615 if you'll be late.`;
        } else if (this.booking_with_team && this.only_team_booking) {
          this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!\n\nIf you are not checked in by game time you risk a $100.00 ‘No Show Fee’. Reply to 403-990-2615 with your name if you’ll be late.`;
        } else {
          this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!\nIf you are not checked in by game time you risk losing your spot to a walk-in and being charged the $80.00 ‘No Show Fee’. Please reply to your organizer by text 403-990-2615 if you will be late with your name.`;
        }
        this.two_hour_reminder_text = this.lastAutoReminderText;
        return;
      }

      const sportsTypes = ["Sports", "Game"];
      if (
        sportsTypes.includes(this.event_type) ||
        sportsTypes.includes(this.game_type)
      ) {
       // this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!\nIf you are not checked in by game time you risk losing your spot to a walk-in and being charged the $80 ‘No Show Fee/Late Fee’. Reply to your organizer by text 403-990-2615 if you will be late with your name.\nIf you cannot attend the game, you must cancel on the app. Do not text cancellations to the organizer.`;
       this.lastAutoReminderText = `Hey {first_name}, you are booked for {event_name} in 2 hours at {start_time} at {address}. See you there!
                          Your host {host_name} will be at the venue early to check you in. A text message will go out when the host arrives to tell you where to find the group. Check-in time: {check_in_time}.
                          If you are not checked in with your host by game time you risk losing your spot to a walk-in and being charged the $80 ‘No Show Fee/Late Fee’.
                          Reply to your organizer by text 403-990-2615 if you will be late with your name.
                          If you cannot attend the game, you must cancel on the app.`;

       this.two_hour_reminder_text = this.lastAutoReminderText;
        return;
      }

      // Social/Hiking/Day Trips/Trips
      const socialTypes = ["Social", "Hiking", "Trips", "Day Trips"];
      if (
        socialTypes.includes(this.event_type) ||
        socialTypes.includes(this.game_type)
      ) {
        //this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!\nIn order for the event to start promptly, we need you to check-in on time. Your host will be at the venue  early to check you in. A text message will go out when the host arrives to tell you where to find the group. \nTo avoid the $80 'No Show Fee/Late Fee’. Reply to your organizer by text 403-990-2615 if you will be late with your name.\nIf you cannot attend the event you must cancel on the app. Do not text cancellations to the organizer.`;
        this.lastAutoReminderText = `Hey {first_name}, you are booked for {event_name} in 2 hours at {start_time} at {address}. See you there!
                            Your host {host_name} will be at the venue early to check you in. A text message will go out when the host arrives to tell you where to find the group. Check-in time: {check_in_time}.
                            If you are not checked in with your host by event time you risk losing your spot to a walk-in and being charged the $80 ‘No Show Fee/Late Fee’.
                            Reply to your organizer by text 403-990-2615 if you will be late with your name.
                            If you cannot attend the event, you must cancel on the app.`;

        this.two_hour_reminder_text = this.lastAutoReminderText;
        return;
      }

      // Walks
      if (this.game_type === "Walks") {
        this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there! \nIn order for the event to start promptly, we need you to check-in on time. Your host {host_name} will be at the venue  early to check you in. Check-in time: {check_in_time}. If you are not checked in by start time, the event will proceed without you. If you’ll be late, reply to 403-990-2615 with your name.`;
        this.two_hour_reminder_text = this.lastAutoReminderText;
        return;
      }

      // Default
      this.lastAutoReminderText = `Hey {first_name}, you are booked for "{event_name}" in 2 hours at {start_time} at {address}. See you there!`;
      this.two_hour_reminder_text = this.lastAutoReminderText;
    },
    Compares() {
      const startTimeInput = document.getElementById("txtStartTime");
      const endTimeInput = document.getElementById("txtEndTime");

      if (!startTimeInput || !endTimeInput) {
        return;
      }

      var strStartTime = startTimeInput.value;
      var strEndTime = endTimeInput.value;
      // var strLateFeeTime = documnet.getElementById("txtLateFeeTime").value;

      if (!strStartTime || !strEndTime) {
        return;
      }

      var startTime = new Date().setHours(
        this.GetHours(strStartTime),
        this.GetMinutes(strStartTime),
        0
      );
      var endTime = new Date(startTime);
      endTime = endTime.setHours(
        this.GetHours(strEndTime),
        this.GetMinutes(strEndTime),
        0
      );
      // var lateFeeTime = new Date().setHours(
      //   this.GetHours(strLateFeeTime),
      //   this.GetMinutes(strLateFeeTime)
      // )
      if (startTime > endTime) {
        this.$apiService.notify("Start Time is greater than end time.");
        return;
      }
      if (startTime == endTime) {
        this.$apiService.notify("Start Time equals end time.");
        return;
      }
      // if (late_fee_date > date) {
      //   this.$apiService.notify("Late Fee Date is not greater then start date.")
      // }
    },
    GetHours(d) {
      var h = parseInt(d.split(":")[0]);
      if (d.split(":")[1].split(" ")[1] == "PM") {
        h = h + 12;
      }
      return h;
    },
    handleUnlimitedChange(value) {
      console.log("Unlimited bookings changed:", value);
      // Reset slots if unlimited bookings is false
      if (value === false || value === "false") {
        this.total_slots = 0;
        this.additional_slots = 0;
      }
    },
    // Watch for changes to event_type/game_type and update reminder text
    onEventTypeOrGameTypeChange() {
      this.generateTwoHourReminderText();
    },

    // GetHours(d) {
    //   if (typeof d !== 'string' || !d.includes(':')) return 0;
    //   const [hoursStr, minAmPm] = d.split(":");
    //   const hour = parseInt(hoursStr);
    //   var isPM = minAmPm && minAmPm.includes("PM");
    //   return isPM ? hour + 12 : hour;
    // },
    GetMinutes(d) {
      return parseInt(d.split(":")[1].split(" ")[0]);
    },
    // GetMinutes(d) {
    //   if (typeof d !== 'string' || !d.includes(':') || !d.includes(' ')) return 0;
    //   return parseInt(d.split(":")[1].split(" ")[0]);
    // },
    syncEndDate() {
      this.endDate = this.date || "";
      return this.endDate;
    },
    buildEventDatePayload() {
      const eventDate = this.syncEndDate();
      return {
        date: eventDate,
        end_date: eventDate,
      };
    },
    buildEventDateTime(dateValue, timeValue) {
      if (!dateValue || !timeValue) {
        return null;
      }

      const [year, month, day] = dateValue.split("-").map(Number);
      const [hours, minutes] = timeValue.split(":").map(Number);
      const eventDateTime = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes
      );

      if (Number.isNaN(eventDateTime.getTime())) {
        return null;
      }

      return eventDateTime;
    },
    parseWholeNumber(value) {
      const parsedValue = Number.parseInt(value, 10);
      return Number.isNaN(parsedValue) ? null : parsedValue;
    },
    validateMinimumPlayers() {
      if (
        this.is_unlimited_bookings === true ||
        this.is_unlimited_bookings === "true"
      ) {
        return true;
      }

      const minimumPlayers = this.parseWholeNumber(this.minimum_players);

      if (minimumPlayers === null || minimumPlayers < 1) {
        this.$apiService.notify("Minimum players is mandatory.");
        return false;
      }

      const totalSlots = this.parseWholeNumber(this.total_slots);

      if (totalSlots === null) {
        return true;
      }

      if (minimumPlayers >= totalSlots) {
        this.$apiService.notify(
          "Minimum players must be less than total slots."
        );
        return false;
      }

      return true;
    },
    validateEventTimeRange({ requireFutureEnd = false } = {}) {
      const startDateTime = this.buildEventDateTime(this.date, this.start_time);
      const endDateTime = this.buildEventDateTime(this.date, this.end_time);

      if (!startDateTime || !endDateTime) {
        this.$apiService.notify("Invalid date or time format.");
        return false;
      }

      if (endDateTime <= startDateTime) {
        this.$apiService.notify("End time must be after start time.");
        return false;
      }

      if (requireFutureEnd && endDateTime < new Date()) {
        this.$apiService.notify("End time must be in the future.");
        return false;
      }

      this.syncEndDate();
      return true;
    },
    async UpdateEve() {
      var id = this.$route.query.id;
      if (
        !this.event_name ||
        !this.address ||
        !this.city ||
        !this.image ||
        (!this.total_slots && !this.is_unlimited_bookings) ||
        !this.description ||
        !this.start_time ||
        !this.end_time ||
        !this.date ||
        !this.event_type ||
        !this.event_environment_type
      ) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }

      if (!this.validateEventTimeRange()) {
        return;
      }

      if (!this.validateMinimumPlayers()) {
        return;
      }
      // ...existing code...

      let imageUrl = this.image;
      if (this.imageUploaded) {
        imageUrl = await this.$apiService.uploadImage(this.image);
      }

      var Evedata = {
        event_name: this.event_name,
        address: this.address, // this is address
        total_slots: this.total_slots,
        minimum_players: this.parseWholeNumber(this.minimum_players),
        additional_slots: this.additional_slots,
        beginner_slots: this.beginner_slots,
        intermediate_slots: this.intermediate_slots,
        advanced_slots: this.advanced_slots,
        team_size: this.team_size,
        description: this.description,
        two_hour_reminder_text: this.two_hour_reminder_text,
        long: this.lng,
        lat: this.lat,
        image: imageUrl,
        early_price: this.early_price,
        day_of_event_fee: this.day_of_event_fee,
        regular_price: this.regular_price,
        is_partial: this.is_partial,
        is_disable_cancellation: this.is_disable_cancellation,
        is_unlimited_bookings: this.is_unlimited_bookings,
        is_dynamic_price: this.is_dynamic_price,
        bots_disabled_buy_cron: this.bots_disabled_buy_cron,
        original_price: this.original_price,
        min_price: this.min_price,
        max_price: this.max_price,
        team_price: this.team_price,
        regular_team_price: this.regular_team_price,
        skill_level_optional: this.skill_level_optional,
        booking_with_team: this.booking_with_team,
        only_team_booking: this.only_team_booking,
        waiver_form_mandatory: this.waiver_form_mandatory,
        no_noshow_and_start_game_reminder:
          this.no_noshow_and_start_game_reminder,
        tournament_type: this.tournament_type,
        individual_slots: this.individual_slots,
        team_slots: this.team_slots,
        men_individual_slots: this.men_individual_slots,
        men_team_count: this.men_team_count,
        men_individual_price: this.men_individual_price,
        men_team_price: this.men_team_price,
        women_individual_slots: this.women_individual_slots,
        women_team_count: this.women_team_count,
        women_individual_price: this.women_individual_price,
        women_team_price: this.women_team_price,
        substitute_player: this.substitute_player,
        late_fee_date: this.late_fee_date,
        late_fee_time: this.late_fee_time,
        check_in_time: this.check_in_time,
        host_request_enabled: this.host_request_enabled,
        // Phase 1 — Task 3F: dedicated no-show charge timing
        auto_no_show_charge_date: this.auto_no_show_charge_date,
        auto_no_show_charge_time: this.auto_no_show_charge_time,
        ...this.buildEventDatePayload(),
        start_time: this.start_time,
        end_time: this.end_time,
        event_type: this.defaultEventType,
        event_environment_type: this.event_environment_type,
        shoe_type: this.shoe_type,
        rental_options: "",
        rental_price: "",
        age_limit: this.age_limit,
        game_type: this.game_type,
        city: this.defaultCity,
        rules: this.rules,
        organizers: this.organizers,
        event_id: this.$route.query.id,
        showUsers: this.showUsers,
        displayRegularPrice: this.displayRegularPrice,
      };

      var update_eve = await this.$apiService.postCall(
        "event/event-update/" + id,
        Evedata
      );

      if (update_eve.apidata.Code === "P00001") {
        this.$apiService.notify("Event has been updated.");
        this.$router.push("/events/list");
      } else {
        this.$apiService.notify(update_eve.apidata.Message);
      }
    },
    async UpdateFutureEvents() {
      var id = this.$route.query.id;
      if (
        !this.event_name &&
        !this.address &&
        !this.image &&
        !this.total_slots &&
        !this.description &&
        !this.start_time &&
        !this.end_time &&
        !this.date &&
        // !this.early_price &&
        // !this.regular_price &&
        // !this.late_fee_date &&
        // !this.late_fee_time &&
        !this.event_type &&
        !this.event_environment_type &&
        !this.shoe_type &&
        !this.game_type
      ) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }
      if (!this.event_name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }

      if (!this.total_slots && !this.is_unlimited_bookings) {
        this.$apiService.notify("Slot is mandatory.");
        return;
      }
      if (!this.validateMinimumPlayers()) {
        return;
      }
      if (!this.early_price && !this.is_dynamic_price) {
        this.$apiService.notify("Early price is mandatory.");
        return;
      }
      if (!this.regular_price && !this.is_dynamic_price) {
        this.$apiService.notify("Regular price is mandatory.");
        return;
      }
      if (!this.original_price && this.is_dynamic_price) {
        this.$apiService.notify("Price is mandatory.");
        return;
      }
      if (!this.min_price && this.is_dynamic_price) {
        this.$apiService.notify("Min price is mandatory.");
        return;
      }
      if (!this.max_price && this.is_dynamic_price) {
        this.$apiService.notify("Max price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.team_price &&
        this.booking_with_team &&
        this.tournament_type == "Open"
      ) {
        this.$apiService.notify("Team price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.regular_team_price &&
        this.booking_with_team &&
        this.tournament_type == "Open"
      ) {
        this.$apiService.notify("Regular team price is mandatory.");
        return;
      }
      if (!this.age_limit) {
        this.$apiService.notify("Age Limit is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.beginner_slots &&
        this.skill_level_optional
      ) {
        this.$apiService.notify("Beginner slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.intermediate_slots &&
        this.skill_level_optional
      ) {
        this.$apiService.notify("Intermediate slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.advanced_slots &&
        this.skill_level_optional
      ) {
        this.$apiService.notify("Advanced slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.team_size &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Team size is mandatory.");
        return;
      }
      if (this.event_type == "Tournament" && !this.tournament_type) {
        this.$apiService.notify("Tournament type is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        this.tournament_type == "Open" &&
        this.booking_with_team &&
        !this.individual_slots &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Individual Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        this.tournament_type == "Open" &&
        this.booking_with_team &&
        !this.team_slots
      ) {
        this.$apiService.notify("Team Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_individual_slots &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Men Individual Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_team_count &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Men Team Count is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_individual_price &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Men Individual Price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_team_price &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Men Team Price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_individual_slots &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Women Individual Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_team_count &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Women Team Count is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_individual_price &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Women Individual Price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_team_price &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Women Team Price is mandatory.");
        return;
      }
      // if (!this.late_fee_date) {
      //   this.$apiService.notify("Late fee date is mandatory.");
      //   return;
      // }
      // if (!this.late_fee_time) {
      //   this.$apiService.notify("Late fee time is mandatory.");
      //   return;
      // }

      if (!this.date) {
        this.$apiService.notify("Date is mandatory.");
        return;
      }
      if (!this.start_time) {
        this.$apiService.notify("Start Time is mandatory.");
        return;
      }

      if (!this.end_time) {
        this.$apiService.notify("End Time is mandatory.");
        return;
      }

      if (!this.validateEventTimeRange()) {
        return;
      }

      if (!this.address) {
        this.$apiService.notify("Location is mandatory.");
        return;
      }
      if (!this.city) {
        this.$apiService.notify("City is mandatory.");
        return;
      }
      if (!this.event_type) {
        this.$apiService.notify("Type of event is mandatory.");
        return;
      }
      if (!this.event_environment_type) {
        this.$apiService.notify("Environment type is mandatory.");
        return;
      }

      if (!this.game_type) {
        this.$apiService.notify("Event GameType is mandatory");
      }
      if (!this.rules) {
        this.$apiService.notify("Rules are mandatory.");
        return;
      }
      if (!this.description) {
        this.$apiService.notify("Description is mandatory.");
        return;
      }

      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      this.loading = true;

      let imageUrl = this.image;
      if (this.imageUploaded) {
        imageUrl = await this.$apiService.uploadImage(this.image);
      }

      var Evedata = {
        event_name: this.event_name,
        address: this.address, // this is address
        total_slots: this.total_slots,
        minimum_players: this.parseWholeNumber(this.minimum_players),
        additional_slots: this.additional_slots,
        description: this.description,
        two_hour_reminder_text: this.two_hour_reminder_text,
        long: this.lng,
        lat: this.lat,
        image: imageUrl,
        early_price: this.early_price,
        day_of_event_fee: this.day_of_event_fee,
        regular_price: this.regular_price,
        is_partial: this.is_partial,
        is_disable_cancellation: this.is_disable_cancellation,
        is_unlimited_bookings: this.is_unlimited_bookings,
        is_dynamic_price: this.is_dynamic_price,
        bots_disabled_buy_cron: this.bots_disabled_buy_cron,
        original_price: this.original_price,
        min_price: this.min_price,
        max_price: this.max_price,
        team_price: this.team_price,
        regular_team_price: this.regular_team_price,
        skill_level_optional: this.skill_level_optional,
        booking_with_team: this.booking_with_team,
        only_team_booking: this.only_team_booking,
        waiver_form_mandatory: this.waiver_form_mandatory,
        no_noshow_and_start_game_reminder:
          this.no_noshow_and_start_game_reminder,
        tournament_type: this.tournament_type,
        individual_slots: this.individual_slots,
        team_slots: this.team_slots,
        men_individual_slots: this.men_individual_slots,
        men_team_count: this.men_team_count,
        men_individual_price: this.men_individual_price,
        men_team_price: this.men_team_price,
        women_individual_slots: this.women_individual_slots,
        women_team_count: this.women_team_count,
        women_individual_price: this.women_individual_price,
        women_team_price: this.women_team_price,
        substitute_player: this.substitute_player,
        // late_fee_date: this.late_fee_date,
        // late_fee_time: this.late_fee_time,
        ...this.buildEventDatePayload(),
        start_time: this.start_time,
        end_time: this.end_time,
        event_type: this.defaultEventType,
        event_environment_type: this.event_environment_type,
        shoe_type: this.shoe_type,
        rental_options: "",
        rental_price: "",
        age_limit: this.age_limit,
        game_type: this.game_type,
        city: this.defaultCity,
        rules: this.rules,
        // organizers: this.organizers,
        showUsers: this.showUsers,
        displayRegularPrice: this.displayRegularPrice,
      };

      var update_all_eve = await this.$apiService.postCall(
        "event/event-update-many/" + id,
        Evedata
      );

      if (update_all_eve.apidata.Code === "P00001") {
        this.$apiService.notify("All Event has been updated.");
        this.$router.push("/events/list");
      } else {
        this.$apiService.notify(update_all_eve.apidata.Message);
      }
    },
    async AddEve() {
      let yesterday = new Date();
      let yester = new Date(yesterday.getTime() - 24 * 60 * 60 * 1000);
      let today = new Date(this.date);
      let lateFeeDate = new Date(this.late_fee_date);
      if (
        !this.event_name &&
        !this.address &&
        !this.image &&
        !this.total_slots &&
        !this.description &&
        !this.start_time &&
        !this.end_time &&
        !this.date &&
        // !this.early_price &&
        // !this.regular_price &&
        // !this.late_fee_date &&
        // !this.late_fee_time &&
        !this.event_type &&
        !this.event_environment_type &&
        !this.shoe_type &&
        !this.game_type
      ) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }
      if (!this.event_name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }
      if (!this.total_slots && !this.is_unlimited_bookings) {
        this.$apiService.notify("Slot is mandatory.");
        return;
      }
      if (!this.validateMinimumPlayers()) {
        return;
      }
      if (!this.early_price && !this.is_dynamic_price) {
        this.$apiService.notify("Early price is mandatory.");
        return;
      }
      if (!this.regular_price && !this.is_dynamic_price) {
        this.$apiService.notify("Regular price is mandatory.");
        return;
      }
      if (!this.original_price && this.is_dynamic_price) {
        this.$apiService.notify("Price is mandatory.");
        return;
      }
      if (!this.min_price && this.is_dynamic_price) {
        this.$apiService.notify("Min price is mandatory.");
        return;
      }
      if (!this.max_price && this.is_dynamic_price) {
        this.$apiService.notify("Max price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.team_price &&
        this.booking_with_team &&
        this.tournament_type == "Open"
      ) {
        this.$apiService.notify("Team price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.regular_team_price &&
        this.booking_with_team &&
        this.tournament_type == "Open"
      ) {
        this.$apiService.notify("Regular team price is mandatory.");
        return;
      }
      if (!this.age_limit) {
        this.$apiService.notify("Age Limit is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.beginner_slots &&
        this.skill_level_optional
      ) {
        this.$apiService.notify("Beginner slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.intermediate_slots &&
        this.skill_level_optional
      ) {
        this.$apiService.notify("Intermediate slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.advanced_slots &&
        this.skill_level_optional
      ) {
        this.$apiService.notify("Advanced slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        !this.team_size &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Team size is mandatory.");
        return;
      }
      if (this.event_type == "Tournament" && !this.tournament_type) {
        this.$apiService.notify("Tournament type is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        this.tournament_type == "Open" &&
        this.booking_with_team &&
        !this.individual_slots &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Individual Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        this.tournament_type == "Open" &&
        this.booking_with_team &&
        !this.team_slots
      ) {
        this.$apiService.notify("Team Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_individual_slots &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Men Individual Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_team_count &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Men Team Count is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_individual_price &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Men Individual Price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Men" || this.tournament_type == "co-ed") &&
        !this.men_team_price &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Men Team Price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_individual_slots &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Women Individual Slots is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_team_count &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Women Team Count is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_individual_price &&
        !this.only_team_booking
      ) {
        this.$apiService.notify("Women Individual Price is mandatory.");
        return;
      }
      if (
        this.event_type == "Tournament" &&
        (this.tournament_type == "Women" || this.tournament_type == "co-ed") &&
        !this.women_team_price &&
        this.booking_with_team
      ) {
        this.$apiService.notify("Women Team Price is mandatory.");
        return;
      }
      // if (!this.late_fee_date) {
      //   this.$apiService.notify("Late fee date is mandatory.");
      //   return;
      // }
      // if (!this.late_fee_time) {
      //   this.$apiService.notify("Late fee time is mandatory.");
      //   return;
      // }
      if (today < yester) {
        this.$apiService.notify("You are adding previous date.");
        this.date = "";
        return;
      }
      if (today < lateFeeDate) {
        this.$apiService.notify("You are adding Next date in late fee date.");
        this.date = "";
        return;
      }
      if (!this.date) {
        this.$apiService.notify("Date is mandatory.");
        return;
      }

      if (!this.start_time) {
        this.$apiService.notify("Start Time is mandatory.");
        return;
      }
      if (!this.end_time) {
        this.$apiService.notify("End Time is mandatory.");
        return;
      }

      if (!this.validateEventTimeRange({ requireFutureEnd: true })) {
        return;
      }
      if (!this.address) {
        this.$apiService.notify("Location is mandatory.");
        return;
      }
      if (!this.city) {
        this.$apiService.notify("City is mandatory.");
        return;
      }
      if (!this.event_type) {
        this.$apiService.notify("Type of event is mandatory.");
        return;
      }

      if (!this.event_environment_type) {
        this.$apiService.notify("Environment type is mandatory.");
        return;
      }
      if (!this.game_type) {
        this.$apiService.notify("Environment Game type is mandatory.");
        return;
      }
      if (!this.rules) {
        this.$apiService.notify("Rules are mandatory.");
        return;
      }
      if (!this.description) {
        this.$apiService.notify("Description is mandatory.");
        return;
      }
      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      this.loading = true;

      const imageUrl = await this.$apiService.uploadImage(this.image);

      let addEvent = await this.$apiService.postCall("event/add", {
        event_name: this.event_name,
        address: this.address,
        total_slots: this.total_slots,
        minimum_players: this.parseWholeNumber(this.minimum_players),
        additional_slots: this.additional_slots,
        beginner_slots: this.beginner_slots,
        intermediate_slots: this.intermediate_slots,
        advanced_slots: this.advanced_slots,
        team_size: this.team_size,
        description: this.description,
        two_hour_reminder_text: this.two_hour_reminder_text,
        image: imageUrl,
        long: this.lng,
        lat: this.lat,
        early_price: this.early_price,
        day_of_event_fee: this.day_of_event_fee,
        regular_price: this.regular_price,
        is_partial: this.is_partial,
        is_disable_cancellation: this.is_disable_cancellation,
        is_unlimited_bookings: this.is_unlimited_bookings,
        is_dynamic_price: this.is_dynamic_price,
        bots_disabled_buy_cron: this.bots_disabled_buy_cron,
        original_price: this.original_price,
        min_price: this.min_price,
        max_price: this.max_price,
        team_price: this.team_price,
        regular_team_price: this.regular_team_price,
        skill_level_optional: this.skill_level_optional,
        booking_with_team: this.booking_with_team,
        only_team_booking: this.only_team_booking,
        waiver_form_mandatory: this.waiver_form_mandatory,
        no_noshow_and_start_game_reminder:
          this.no_noshow_and_start_game_reminder,
        tournament_type: this.tournament_type,
        individual_slots: this.individual_slots,
        team_slots: this.team_slots,
        men_individual_slots: this.men_individual_slots,
        men_team_count: this.men_team_count,
        men_individual_price: this.men_individual_price,
        men_team_price: this.men_team_price,
        women_individual_slots: this.women_individual_slots,
        women_team_count: this.women_team_count,
        women_individual_price: this.women_individual_price,
        women_team_price: this.women_team_price,
        substitute_player: this.substitute_player,
        late_fee_date: this.late_fee_date,
        late_fee_time: this.late_fee_time,
        check_in_time: this.check_in_time,
        host_request_enabled: this.host_request_enabled,
        // Phase 1 — Task 3F: dedicated no-show charge timing
        auto_no_show_charge_date: this.auto_no_show_charge_date,
        auto_no_show_charge_time: this.auto_no_show_charge_time,
        ...this.buildEventDatePayload(),
        start_time: this.start_time,
        city: this.defaultCity,
        end_time: this.end_time,
        event_type: this.defaultEventType,
        event_environment_type: this.event_environment_type,
        shoe_type: this.shoe_type,
        rental_options: "",
        age_limit: this.age_limit,
        rental_price: "",
        game_type: this.game_type,
        rules: this.rules,
        isRepeate: this.isRepeate,
        repeat_on_every: this.repeat_on_every,
        repeat_end_date: this.repeat_end_date,
        repeat_end_date_value: this.repeat_end_date_value,
        organizers: this.organizers,
        showUsers: this.showUsers,
        displayRegularPrice: this.displayRegularPrice,
      });
      if (addEvent.apidata.Code === "P00001") {
        this.$apiService.notify("Event has been added.");
        this.$router.push("/events/list");
      } else {
        this.$apiService.notify(addEvent.apidata.Message);
      }
      this.loading = false;
    },
    repeateEndDate() {
      console.log("date  = ", this.date);
      this.repeat_end_date_value = "";
    },
    onImageChange(file) {
      this.image = file;
      this.imageUploaded = true;
    },
    onlyNum(field) {
      let value = (this[field] || "").toString();

      // Keep only digits
      value = value.replace(/[^0-9]/g, "");

      // Prevent scientific notation (e.g., "1e5")
      if (!isFinite(value)) {
        value = "";
      }

      this[field] = value;
    },
    numericcost(field) {
      let value = (this[field] || "").toString();

      // Remove everything except digits and dot
      value = value.replace(/[^0-9.]/g, "");

      // Remove multiple dots
      const parts = value.split(".");
      if (parts.length > 1) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      // Remove if starts with a dot (e.g. ".45")
      if (value.startsWith(".")) {
        value = "";
      }

      // Prevent scientific notation like "1e5"
      if (!isFinite(value)) {
        value = "";
      }

      this[field] = value;
    },
    assignToEvent() {
      if (
        this.popUpValue !== "" &&
        this.popUpValue !== null &&
        this.popUpValue !== undefined
      ) {
        if (
          this.organizers.findIndex(
            (organizer) => organizer.userId == this.popUpValue
          ) !== -1
        ) {
          this.$apiService.notify("User already exists in orgainzer list");
        } else {
          console.log(this.popUpValue);
          this.organizers.push({
            userId: this.popUpValue,
            userName: this.popUpText,
            bookedAsPlayer: this.isChecked,
            botCanCancel: this.isBotCancel,
          });
        }
      } else {
        this.$apiService.notify("please select the user correctly");
      }
    },
    remove(userId) {
      if (userId !== null && userId !== "" && userId !== undefined) {
        this.organizers = this.organizers.filter(
          (organizer) => organizer.userId != userId
        );
      } else {
        this.$apiService.notify("User not exist in the organizer list");
      }
    },
    getValueOfList(value, text) {
      this.popUpValue = value;
      this.popUpText = text;
    },
  },
  watch: {
    is_dynamic_price() {
      this.event_type = this.defaultEventType;
    },
    date(newDate) {
      this.endDate = newDate || "";
    },

    is_unlimited_bookings(newVal) {
      // This function runs whenever the switch changes
      this.handleUnlimitedChange(newVal);
    },

    event_type() {
      this.onEventTypeOrGameTypeChange();
    },
    game_type() {
      this.onEventTypeOrGameTypeChange();
    },
    booking_with_team() {
      this.onEventTypeOrGameTypeChange();
    },
    only_team_booking() {
      this.onEventTypeOrGameTypeChange();
    },
    individual_slots() {
      this.onEventTypeOrGameTypeChange();
    },
    team_slots() {
      this.onEventTypeOrGameTypeChange();
    },
    no_noshow_and_start_game_reminder() {
      this.generateTwoHourReminderText();
    },
  },
  created() {
    this.generateTwoHourReminderText();
  },
};
</script>
<style>
.form-check .form-check-label {
  font-size: 16px;
}

.left-spacer {
  margin-left: 25px;
}

.location {
  background: #27293d !important;
  border: 1px solid #2b3553;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  color: white;
}

.event-edit-page input[type="date"],
.event-edit-page input[type="time"] {
  color-scheme: dark;
}

.event-edit-page input[type="date"]::-webkit-calendar-picker-indicator,
.event-edit-page input[type="time"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  filter: brightness(0) invert(1);
  opacity: 1;
}

form label {
  font-weight: 600;
}

.coordinate {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 5px;
  font-size: 14px;
  border-radius: 5px;
  color: white;
}

.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 9px;
  left: 19px;
  content: " ";
  display: block;
  background: #e14eca;
}

.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 15px;
  margin: 10px 0 0;
}

.radio-item input[type="radio"] {
  display: none;
}

.radio-item label {
  color: white;
  font-weight: 600;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid white;
  background-color: transparent;
}

.row > p {
  justify-items: center;
  justify-content: center;
  justify-self: center;
}
</style>
